module.exports = __webpack_public_path__ + "static/media/searchBar.35e43c16.svg";